import angular from 'angular';
import config from './account-settings.routes';
import { AccountDataController } from './account-data/account-data.controller';
import { AccountHistoryController } from './account-history/account-history.controller';
import { AccountSettingsController } from './account-settings.controller';
import { AccountAddonsPackagesController } from './addons-packages/addons-packages.controller';
import { InvoicesController } from './invoices/invoices.controller';
import { PaymentSetupController } from './payment-setup/payment-setup.controller';
import { UsersController } from './users/users.controller';
import { AuditController, audit } from './account-history/audit/audit.directive';
import { DiffController, diff } from './account-history/diff/diff.directive';
import { MessageController, message } from './account-history/message/message.directive';
import { BillingDetailsController, billingDetails } from './payment-setup/billing-details/billing-details.directive';
import { PermissionsController, permissions } from './users/permissions/permissions.directive';

export default angular
  .module('adjust.account-settings', [])
  .config(config)
  .controller('AccountDataController', AccountDataController)
  .controller('AccountHistoryController', AccountHistoryController)
  .controller('AccountSettingsController', AccountSettingsController)
  .controller('AccountAddonsPackagesController', AccountAddonsPackagesController)
  .controller('InvoicesController', InvoicesController)
  .controller('PaymentSetupController', PaymentSetupController)
  .controller('UsersController', UsersController)
  .controller('AuditController', AuditController)
  .directive('audit', audit)
  .controller('DiffController', DiffController)
  .directive('diff', diff)
  .controller('MessageController', MessageController)
  .directive('message', message)
  .controller('BillingDetailsController', BillingDetailsController)
  .directive('billingDetails', billingDetails)
  .controller('PermissionsController', PermissionsController)
  .directive('permissions', permissions).name;
